<mat-form-field
  [appearance]="appearance"
  [class]="class"
  [dir]="direction"
  [floatLabel]="floatLabelType"
  (click)="openDatePicker()"
  >
  @if (!!label) {
    <mat-label class="text-sm">{{ label }}</mat-label>
  }
  <!--
    a11y: [aria-describedby] (property binding, not [attr.]) so MatInput's @Input fires and
    MatFormField merges/keeps the error id when re-syncing aria-describedby on the host element.
  -->
  <input
    matInput
    [formControl]="formControl"
    [matDatepicker]="picker"
    [min]="minDate"
    [max]="maxDate"
    (dateChange)="onDateChange.emit($event)"
    readonly
    [aria-describedby]="(formControl.invalid && formControl.touched && displayErrors) ? errorId : null"
    [attr.aria-invalid]="(formControl.invalid && formControl.touched) ? 'true' : null"
    />
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [startAt]="startDate"></mat-datepicker>
  </mat-form-field>

  @if (formControl.invalid && formControl.touched && !!displayErrors) {
    <mat-error
      [id]="errorId"
      class="error"
      role="alert"
      aria-live="assertive"
      style="color: red; text-align: left">
      {{ getFirstError() }}
    </mat-error>
  }
